import React, { memo } from 'react';
import productParameterConfigs from './config';
import ProductParameterEditor from './ProductParameterEditor';
function ProductMainCategoryEditor({ create = false }) {
    return React.createElement(ProductParameterEditor, { config: productParameterConfigs.mainCategories, create: create });
}
export default memo(ProductMainCategoryEditor);
